/*global ajaxurl */
import axios from "axios";
import Qs from "qs";

export default {
  init() {
    /**
     *  on product eifu dropdown change get languge template part via ajax
     */
    $(document).on("change", "[name=ifu_product]", function () {
      let product = $(this).val();
      let type = "ifu";

      $("#results1").empty();

      if (product) {
        let data = {
          action: "get_ifu_products",
          product: product,
          type: type,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
          if (response.data.success == true) {
            $("#results1").append(response.data.data.template);
          } else {
            $("#results1").append(response.data.data.message);
          }
        });
      }
    });

    /**
     *  on product ics dropdown change get kit template part via ajax
     */
    $(document).on("change", "[name=iii_product]", function () {
      let lang = $(this).val();
      let type = "instruments-inspection-instruction";

      $("#results2").empty();

      if (lang) {
        let data = {
          action: "get_documents",
          lang: lang,
          type: type,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
          if (response.data.success == true) {
            $("#results2").append(response.data.data.template);
          } else {
            $("#results2").append(response.data.data.message);
          }
        });
      }
    });

    /**
     *  on product ics dropdown change get kit template part via ajax
     */
    $(document).on("change", "[name=ics_product]", function () {
      let product = $(this).val();
      let type = "inventory-controll-sheet";

      $("#results3").empty();

      if (product) {
        let data = {
          action: "get_documents",
          product: product,
          type: type,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
          if (response.data.success == true) {
            $("#results3").append(response.data.data.template);
          } else {
            $("#results3").append(response.data.data.message);
          }
        });
      }
    });

    /**
     *  on language dropdown get documents
     */
    $(document).on("change", "[name=ifu_lang]", function () {
      let lang = $(this).val();
      let product = $("[name=ifu_product]").val();
      let type = "ifu";

      if (lang) {
        let data = {
          action: "get_documents",
          lang: lang,
          product: product,
          type: type,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
          $("#results1").empty();
          $("#results1").append(response.data.data.template);
        });
      }
    });

    /**
     *  on kit dropdown get documents
     */
    $(document).on("change", "[name=ics_kit]", function () {
      let kit = $(this).val();
      let product = $("[name=ics_product]").val();
      let type = "inventory-controll-sheet";

      if (kit) {
        let data = {
          action: "get_documents",
          kit: kit,
          product: product,
          type: type,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
          $("#results2").empty();
          $("#results2").append(response.data.data.template);
        });
      } else {
        $("#results2").empty();
      }
    });

    $("select").select2();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/ifu.js